<div class="scrollContainer">
  <ng-content select="app-survey-frame-list-template"></ng-content>
  <ng-content select="app-survey-frame-tab-template"></ng-content>
</div>
